export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			$slides: null,
		};
		this.options = {};
		this.$speed = 2000;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "imgCycle";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.$slides = this.$el.querySelectorAll("img");
			this.$slides[0].classList.add("active");
			if (this.$el.classList.contains("feed-cycle-img")) {
				this.$speed = 1000;
			}
			setTimeout(() => {
				this.cycle();
			}, this.$speed);
		}
	}
	cycle() {
		let $active = this.$el.querySelector(".active");
		let $next = $active.nextElementSibling;
		if (!$next) {
			$next = this.$slides[0];
		}
		$active.classList.remove("active");
		$next.classList.add("active");

		clearTimeout(this.cycleTimer);
		this.cycleTimer = setTimeout(() => {
			this.cycle();
		}, this.$speed);
	}
}
